import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import { Kbd } from "@/components/ui/kbd";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  ariaKeyshortcuts,
  formatShortcut,
} from "components/RichEditor/toolbar/shortcut";

// The primitive binds mod+B on window; this mirrors it for display only.
const TOGGLE_SHORTCUT = ["mod", "b"];

// The rail's collapse control: the sidebar trigger with a tooltip naming the
// Cmd/Ctrl+B shortcut. Shared by the global rail and the detail rail. The
// trigger's icon-sm button is 28px; in the collapsed rail it is sized to 32px to
// match the menu rows. The label names the action the next press performs, and
// overrides the primitive's fixed "Toggle Sidebar" text as the accessible name.
export default function SidebarToggleButton() {
  const { isMobile, open, openMobile } = useSidebar();
  const isExpanded = isMobile ? openMobile : open;
  const label = isExpanded ? "Collapse sidebar" : "Expand sidebar";

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <SidebarTrigger
            aria-label={label}
            aria-keyshortcuts={ariaKeyshortcuts(TOGGLE_SHORTCUT)}
            className="tw:shrink-0 tw:group-data-[collapsible=icon]:size-8"
          />
        }
      />
      <TooltipContent>
        {label} <Kbd>{formatShortcut(TOGGLE_SHORTCUT)}</Kbd>
      </TooltipContent>
    </Tooltip>
  );
}
